import { loadModule } from '../loadModule'
import type { ModuleFederationContainer, WebpackSharedScope } from '../types'

export async function loadComponentWithModuleFederation(
	moduleFederationEntryUrl: string,
	widgetName: string,
	sharedScope: WebpackSharedScope,
	withRequireJs = true
) {
	const container = await loadModule<ModuleFederationContainer>(moduleFederationEntryUrl, widgetName, withRequireJs)
	const component = await loadComponent(container, widgetName, sharedScope)
	return component
}

async function loadComponent(container: ModuleFederationContainer, module: string, sharedScope: WebpackSharedScope) {
	await container.init(sharedScope)
	const factory = await container.get(module)
	const component = factory()
	return component
}
